import MessageAdListViewStatusStore from '../store/schema/MessageAdListViewStatusStore';
import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';

export interface ResetMessageAdListSelectionState {
    messageAdListViewStatusStore: MessageAdListViewStatusStore;
}

export default action('resetMessageAdListSelection')(function (
    state: ResetMessageAdListSelectionState = { messageAdListViewStatusStore: store }
): void {
    if (state?.messageAdListViewStatusStore) {
        state.messageAdListViewStatusStore.selectedAdId = null;
    }
});
